var carouselContainers = document.querySelectorAll(
	'.pl_custom_carousel-container'
);

carouselContainers.forEach(function(carouselContainer) {
	var carousel = carouselContainer.querySelector(
		'.pl_custom_carousel-carousel'
	);
	var slides = carousel.querySelectorAll('.pl_custom_carousel-slide');
	function getSlideStep() {
		if (!slides.length) return 0;
		var styles = window.getComputedStyle(slides[0]);
		var marginRight = parseFloat(styles.marginRight || '0');
		return slides[0].getBoundingClientRect().width + marginRight;
	}

	var slideWidth = getSlideStep();
	var progressBar = carouselContainer.querySelector(
		'.pl_custom_carousel-carousel-progress .pl_custom_carousel-carousel-progress-fill'
	);
	var prevButton = carouselContainer.querySelector(
		'.pl_custom_carousel-prev-btn'
	);
	var nextButton = carouselContainer.querySelector(
		'.pl_custom_carousel-next-btn'
	);
	var slideIndex = 0;
	var startX;
	var isDragging = false;

	function getVisibleCount() {
		var containerWidth = carouselContainer.clientWidth;
		var step = getSlideStep();
		if (step <= 0) return 1;
		var count = Math.floor(containerWidth / step);
		return count > 0 ? count : 1;
	}

	function getMaxIndex() {
		var visibleCount = getVisibleCount();
		var maxIndex = slides.length - visibleCount;
		return maxIndex > 0 ? maxIndex : 0;
	}

	function updateNavButtons() {
		var maxIndex = getMaxIndex();
		prevButton.style.display = slideIndex === 0 ? 'none' : 'block';
		nextButton.style.display = slideIndex >= maxIndex ? 'none' : 'block';
	}

	function slideTo(index) {
		var maxIndex = getMaxIndex();
		if (index < 0 || index > maxIndex) {
			return;
		}

		var translateX = -(index * slideWidth);
		carousel.style.transform = 'translateX(' + translateX + 'px)';
		slideIndex = index;

		updateNavButtons();

		var progress = maxIndex > 0 ? (index / maxIndex) * 100 : 100;
		progressBar.style.width = progress + '%';

		if (index > 0) {
			progressBar.classList.add(
				'pl_custom_carousel-carousel-progress-active'
			);
		} else {
			progressBar.classList.remove(
				'pl_custom_carousel-carousel-progress-active'
			);
		}
	}

	function slidePrev() {
		slideTo(slideIndex - 1);
	}

	function slideNext() {
		slideTo(slideIndex + 1);
	}

	function handleTouchStart(event) {
		isDragging = true;
		startX = event.touches[0].clientX;
	}

	function handleTouchMove(event) {
		if (!isDragging) {
			return;
		}

		var currentX = event.touches[0].clientX;
		var diffX = currentX - startX;

		if (diffX > 0) {
			slidePrev();
		} else if (diffX < 0) {
			slideNext();
		}

		isDragging = false;
	}

	function resetCarouselPosition() {
		carousel.style.transform = 'translateX(0)';
	}

	resetCarouselPosition();
	updateNavButtons();

	prevButton.addEventListener('click', slidePrev);
	nextButton.addEventListener('click', slideNext);
	carouselContainer.addEventListener('touchstart', handleTouchStart);
	carouselContainer.addEventListener('touchmove', handleTouchMove);
	window.addEventListener('resize', function() {
		slideWidth = getSlideStep();
		if (slideIndex > getMaxIndex()) {
			slideIndex = getMaxIndex();
		}
		slideTo(slideIndex);
	});
});
